<i class="spinner fas fa-circle-notch fa-spin fa-3x fa-fw"></i>
<img class="inner-img" [src]="_src" [alt]="_alt" (load)="_imageLoaded()"/>
<ng-content *ngIf="_mode === 'cover'"></ng-content>
